import { useCallback, useState } from 'react'

export function useToggle(initial = false): [boolean, (force?: unknown) => void] {
  const [value, setValue] = useState(initial)

  const toggle = useCallback(
    (force?: unknown) => {
      setValue((prev) => {
        return typeof force === 'boolean' ? force : !prev
      })
    },
    [setValue]
  )

  return [value, toggle]
}
